import { CommonModule } from '@angular/common';
import { Component, computed, input, output, TemplateRef, viewChild } from '@angular/core';

import { IPaginationResponseResolver, ISoftDeletablePaginationParameters } from '../../../data-access';
import { IActionConfig, IActionExecutedEvent, IDialogConfig, ITableConfig } from '../../../ui';
import { ISoftDeletableAuditableLookup } from '../../../primitives';
import { SoftDeletableAuditableEntitiesComponent } from '../../../entities';

@Component({
  selector: 'app-soft-deletable-auditable-lookups',
  standalone: true,
  providers: [],
  imports: [CommonModule, SoftDeletableAuditableEntitiesComponent],
  templateUrl: './soft-deletable-auditable-lookups.component.html',
  styleUrls: ['./soft-deletable-auditable-lookups.component.scss']
})
export class SoftDeletableAuditableLookupsComponent<
  TEntity extends ISoftDeletableAuditableLookup<string>,
  TPaginationParameters extends ISoftDeletablePaginationParameters
> {
  tableRowTemplate = viewChild.required<TemplateRef<{ $implicit: TEntity }>>('tableRowTemplate');
  paginationResponseResolver = input.required<IPaginationResponseResolver<TEntity, TPaginationParameters>>();
  defaultPaginationParameters = input.required<TPaginationParameters>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  tableConfig = input<ITableConfig>();

  actionExecuted = output<IActionExecutedEvent<TEntity>>();

  finalTableConfig = computed(() => ({
    fields: [{ name: 'englishName', displayName: 'GENERAL.ENGLISH_NAME' }, ...(this.tableConfig()?.fields ?? [])],
    template: this.tableRowTemplate()
  }));

  onActionExecuted(event: unknown) {
    this.actionExecuted.emit(event as IActionExecutedEvent<TEntity>);
  }
}
